// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\ReleaseNoteReactionResponse

import { ReleaseNoteReactionType } from './enums.gen';

export type ReleaseNoteReactionApiResponse = {
	id: number;
	business: { id: string; name: string };
	user: { id: string; fullName: string };
	reaction: ReleaseNoteReactionType;
};

export type ReleaseNoteReaction = {
	id: number;
	business: { id: string; name: string };
	user: { id: string; fullName: string };
	reaction: ReleaseNoteReactionType;
};

export function hydrateReleaseNoteReaction(data: ReleaseNoteReactionApiResponse): ReleaseNoteReaction {
	return { ...data };
}